if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.error = this.querySelector('[data-terms-error]');

      if (!this.checkbox) return;

      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) this.clearError();
      });

      if (!document.__pdTermsGuard) {
        document.__pdTermsGuard = true;
        document.addEventListener('click', (event) => {
          const button = event.target.closest('#CheckOut');
          if (!button) return;
          const boxes = Array.from(document.querySelectorAll('terms-checkbox'))
            .filter((el) => el.offsetParent !== null && el.checkbox);
          if (!boxes.length) return;
          const unchecked = boxes.filter((el) => !el.checkbox.checked);
          if (unchecked.length) {
            event.preventDefault();
            event.stopImmediatePropagation();
            unchecked[0].flagError();
          }
        }, true);
      }
    }

    flagError() {
      if (this.error) this.error.hidden = false;
      this.classList.add('terms-checkbox--error');
      this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { this.checkbox.focus({ preventScroll: true }); } catch (e) { this.checkbox.focus(); }
    }

    clearError() {
      if (this.error) this.error.hidden = true;
      this.classList.remove('terms-checkbox--error');
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
